import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Classes from "./AddSubscription.module.css";
import ClientsDropDown from "./ClientsDropDown";

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
)

export default function AddSubscription() {
    const navigateTo = useNavigate();
    const [selectedClient, setselectedClient] = useState(null);
    const clients = [
        { id: 1, name: "John Smith", email: "johnsmith@gmail.com" },
        { id: 2, name: "Jane Doe", email: "janedoe@gmail.com" }
    ];

    const handleBackClick = () => navigateTo("/subscriptions");

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Data:", {

        });
    };

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <button onClick={handleBackClick} className={Classes.backButton}>
                    <LeftArrow height='13px' fill='#969696' />
                    <h5>Subscriptions</h5>
                </button>
            </div>
            <div className={Classes.hero2}>
                <h3>Add subscription</h3>

                <form onSubmit={handleSubmit}>

                    <div className={Classes.flexColGroup} >
                        <div className={Classes.flexCol1}>
                            <div className="flexAlign10" >
                                <label className={Classes.label}>Client</label>
                                <div className={Classes.optionalText} > <h5>Optional</h5> </div>
                            </div>
                            <ClientsDropDown
                                clients={clients}
                                selectedClient={selectedClient}
                                setselectedClient={setselectedClient}
                            />
                        </div>
                        <div className={Classes.flexCol1}>
                            <label className={Classes.label}>Due date</label>
                            <input
                                type="date"
                                className={Classes.inputField}
                                placeholder="Due date"
                            />
                        </div>
                    </div>

                    <div className={Classes.flexColGroup} >
                        <div className={Classes.flexCol1}>
                            <label className={Classes.label}>Price</label>
                            <input
                                type="text"
                                className={Classes.inputField}
                                placeholder="$0.00"
                            />
                        </div>
                        <div className={Classes.flexCol1}>
                            <label className={Classes.label}>Discount</label>
                            <input
                                type="text"
                                className={Classes.inputField}
                                placeholder="John"
                            />
                        </div>
                        <div className={Classes.flexCol1}>
                            <label className={Classes.label}>Quantity</label>
                            <input
                                type="text"
                                className={Classes.inputField}
                                placeholder="1"
                            />
                        </div>
                    </div>

                    <div className={Classes.flexCol1} >
                        <label className={Classes.label}>Item</label>
                        <input
                            type="text"
                            className={Classes.inputField}
                            placeholder="Item custom line"
                        />
                        <input
                            type="text"
                            className={Classes.inputField}
                            placeholder="Item name"
                        />
                        <textarea
                            rows="3"
                            className={Classes.inputField}
                            placeholder="Description"
                            style={{ resize: "none" }}
                        ></textarea>

                        <button className={Classes.addLineBtn} >
                            <svg xmlns="http://www.w3.org/2000/svg" height='12px' fill="black" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" /></svg>
                            <h5>Add line item</h5>
                        </button>
                    </div>

                    <div className={Classes.options} >

                    </div>
                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>Note to client</label>
                        <textarea
                            rows="7"
                            className={Classes.inputField}
                            placeholder="Start typing..."
                            style={{ resize: "none" }}
                        ></textarea>
                    </div>

                    <div className={Classes.option} >
                        <input
                            type="checkbox"
                            id="check1"
                        />
                        <div>
                            <label htmlFor="check1" >
                                <h5>Send email notification</h5>
                                <p>If you don't notify the client, they will still see the invoice in their account.</p>
                            </label>
                        </div>
                    </div>

                    <div className={Classes.option} >
                        <input
                            type="checkbox"
                            id="check2"
                        />
                        <div>
                            <label htmlFor="check2" >
                                <h5>Partial upfront payment</h5>
                                <p>If you want to collect a deposit upfront and charge the remaining amount later.</p>
                            </label>
                        </div>
                    </div>

                    <div className={Classes.option} >
                        <input
                            type="checkbox"
                            id="check3"
                        />
                        <div>
                            <label htmlFor="check3" >
                                <h5>Custom billing date</h5>
                                <p>If you want the Stripe subscription to start at a specific date. Current date will be used if the invoice is not paid before this billing date.</p>
                            </label>
                        </div>
                    </div>

                    <div className={Classes.option} >
                        <input
                            type="checkbox"
                            id="check4"
                            style={{ marginTop: '2px' }}
                        />
                        <div>
                            <label htmlFor="check4" >
                                <h5>Custom currency</h5>
                            </label>
                        </div>
                    </div>

                    <div className={Classes.flexEnd}>
                        <button type="submit" className={Classes.submitBtn}>
                            <h5>Add subscription</h5>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
